import { object } from "yup";

import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";
import { dbIdValidationSchema, titleValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  title: titleValidationSchema,
  contractId: dbIdValidationSchema,
  price: templateAssetValidationSchema,
});
